export default __webpack_public_path__ + "static/media/BASED.1b18c647.svg";